import { render, staticRenderFns } from "./NoClientPaymentAccount.vue?vue&type=template&id=f72e7024&scoped=true&"
import script from "./NoClientPaymentAccount.vue?vue&type=script&lang=js&"
export * from "./NoClientPaymentAccount.vue?vue&type=script&lang=js&"
import style0 from "./NoClientPaymentAccount.vue?vue&type=style&index=0&id=f72e7024&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f72e7024",
  null
  
)

export default component.exports